import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { NgxSpinnerService } from 'ngx-spinner';
import { AppService } from 'src/app/services/app/app.service';
import { CommonService } from 'src/app/services/common/common.service';
import { UserManagementService } from 'src/app/services/user_management/user-management.service';
export interface PeriodicElement {
  name: string;
  position: number;
  weight: number;
  symbol: string;
}
const ELEMENT_DATA: PeriodicElement[] = [
  { position: 1, name: 'Hydrogen', weight: 1.0079, symbol: 'H' },
  { position: 2, name: 'Helium', weight: 4.0026, symbol: 'He' },
  { position: 3, name: 'Lithium', weight: 6.941, symbol: 'Li' },
  { position: 4, name: 'Beryllium', weight: 9.0122, symbol: 'Be' },
  { position: 5, name: 'Boron', weight: 10.811, symbol: 'B' },
  { position: 6, name: 'Carbon', weight: 12.0107, symbol: 'C' },
  { position: 7, name: 'Nitrogen', weight: 14.0067, symbol: 'N' },
  { position: 8, name: 'Oxygen', weight: 15.9994, symbol: 'O' },
  { position: 9, name: 'Fluorine', weight: 18.9984, symbol: 'F' },
  { position: 10, name: 'Carbon', weight: 12.0107, symbol: 'C' },
  { position: 11, name: 'Nitrogen', weight: 14.0067, symbol: 'N' },
  { position: 12, name: 'Oxygen', weight: 15.9994, symbol: 'O' },
  { position: 13, name: 'Fluorine', weight: 18.9984, symbol: 'F' },
  { position: 1, name: 'Hydrogen', weight: 1.0079, symbol: 'H' },
  { position: 2, name: 'Helium', weight: 4.0026, symbol: 'He' },
  { position: 3, name: 'Lithium', weight: 6.941, symbol: 'Li' },
  { position: 4, name: 'Beryllium', weight: 9.0122, symbol: 'Be' },
  { position: 5, name: 'Boron', weight: 10.811, symbol: 'B' },
  { position: 6, name: 'Carbon', weight: 12.0107, symbol: 'C' },
]
// {
//   "u_t": "manager", // user type 
//   "u_d": [   // user data 
//       {
//           "f_n": "asdasda", //first name 
//           "l_n": "adas",  // last name 
//           "el": "a@asdas.com", //email 
//           "pwd": "12345678", //password
//           "c_pwd": "12345678"  //confirm password
//       }
//   ]
// }
@Component({
  selector: 'app-add-user',
  templateUrl: './add-user.component.html',
  styleUrls: ['./add-user.component.scss']
})
export class AddUserComponent {
  public displayedColumns: string[] = [];
  public displayedColumnsCom: string[] = ['No.', 'first_name','email', 'password', 'confirm_password', 'action'];
  public displayedColumnsMan: string[] = ['No.', 'first_name', 'last_name', 'email', 'password', 'confirm_password', 'action'];
  public displayedColumnsEmp: string[] = ['No.',  'email', 'message','action'];
  public dataSource: any;
  public userArr: any[] = [];
  public isError: boolean = false;
  public errorMessage: string = "";
  constructor(private userService: UserManagementService, private commonService: CommonService,
    @Inject(MAT_DIALOG_DATA) public dialogData: any, public dialogRef: MatDialogRef<AddUserComponent>,
    private appService: AppService, private spinner: NgxSpinnerService) { }
  ngOnInit(): void {
    //Called after the constructor, initializing input properties, and the first call to ngOnChanges.
    //Add 'implements OnInit' to the class.
    // this.dataSource.data()
    if(this.dialogData.userType=="employee"){
      this.displayedColumns=this.displayedColumnsEmp
      this.userArr = [
        { el:"", msg:""},
        // { el:"", msg:""},
      ]
    }
    else if(this.dialogData.userType=="company"){
      this.displayedColumns=this.displayedColumnsCom
      this.userArr = [
        { f_n: "", el: '', pwd: "", c_pwd: "" },
      ]
    }
    else{
      this.displayedColumns=this.displayedColumnsMan
      this.userArr = [
        { f_n: "", l_n: "", el: '', pwd: "", c_pwd: "",access: "[]" },
        // { f_n: "", l_n: "", el: '', pwd: "", c_pwd: "" },
      ]
    }
    this.dataSource = new MatTableDataSource(this.userArr)
    if (this.dialogData.dataType == 'csv') {
      this.userArr = []
      this.userArr = [...this.dialogData.data]
      this.dataSource = new MatTableDataSource(this.userArr)
    }
 
  }
  onAddMore() {
    let obj: {} = {}
    if(this.dialogData.userType=="employee"){
       obj= {
         el: '',
         msg:''       
      }
    }
    else if(this.dialogData.userType=="company"){
      obj= { f_n: "", el: '', pwd: "", c_pwd: "" }
    }
    else{
     obj = {
        f_n: '',
        l_n: "",
        el: '',
        pwd: "",
        c_pwd: "",
      }
    }
 
    this.userArr.push(obj)
    this.dataSource = new MatTableDataSource(this.userArr)
  }
  onDeleteItem(i: any) {
    this.userArr.splice(i, 1)
    this.dataSource = new MatTableDataSource(this.userArr)
  }
  onSave() {
    this.errorMessage = "";
    if (this.userArr.length == 0) {
      this.errorMessage = 'Please add users to save'
    }
    // below validation for manager only
    if(this.dialogData.userType!="employee"){
      for (let i = 0; i < this.userArr.length; i++) {
        const user = this.userArr[i];

        const keysToCheck = ["f_n", "l_n", "el", "pwd", "c_pwd"];
        let isEmpty = false;
        for (let i = 0; i < keysToCheck.length; i++) {
          const key = keysToCheck[i];
          if ((key!='pwd' && key!='c_pwd') && user[key] == "") {
            this.errorMessage = "No element in the object should be empty. User index: " + (i + 1)
            break; // Exit the loop early if an empty string is found
          }
          if((key=='pwd' || key=='c_pwd') && user[key]==''){
            this.errorMessage = "No element in the object should be empty. User index: " + (i + 1)
            break; // Exit
          }
        }
        if (user.pwd.length < 8) {
          this.errorMessage = "Password should be at least 8 characters long. User index: " + (i + 1)
          console.error("Error: Password should be at least 8 characters long. User index: " + (i + 1));
          return false;
        }
        if (user.pwd !== user.c_pwd) {
          this.errorMessage = "Password and confirm password should match. User index: " + (i + 1)
          console.error("Error: Password and confirm password should match. User index: " + (i + 1));
          return false;
        }
        if (!this.validateEmail(user.el)) {
          this.errorMessage = "Email should be in a valid format. User index: " + (i + 1)
          console.error("Error: Email should be in a valid format. User index: " + (i + 1));
          return false;
        }
      }
    }
    else{
      for (let i = 0; i < this.userArr.length; i++) {
        const user = this.userArr[i];

        const keysToCheck = ["el","msg"];
        let isEmpty = false;
        for (let i = 0; i < keysToCheck.length; i++) {
          const key = keysToCheck[i];
          if((key=='el') && user[key]==''){
            this.errorMessage = "No element in the object should be empty. User index: " + (i + 1)
            break; // Exit
          }
  
        }
    
        if (!this.validateEmail(user.el)) {
          this.errorMessage = "Email should be in a valid format. User index: " + (i + 1)
          console.error("Error: Email should be in a valid format. User index: " + (i + 1));
          return false;
        }
// adding on 15/3/2024
        if(user.el){
          user.el=user.el.trim()
        }
      }
    }
    
    if (this.errorMessage == "") {
      // this.onSaveUserAPI()
    this.onSubmit()
    }
    return true;

  }
  validateEmail(email:string) {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email.trim());
  }
  onSubmit(){
    if(this.dialogData.userType=="employee"){
      this.onSaveAPIEmp()
    }
    else{
      this.onSaveUserAPI()

    }
  }
  onSaveAPIEmp(){
    let obj: {} = {
      "u_d": this.userArr
    }
    if (this.userArr.length > 0) {
      this.spinner.show()
      this.userService.addEmp(obj).subscribe({
        next: (data) => {
          if (data.status == 200) {
            this.spinner.hide();
            this.appService.showToastMessage("success", data.msg);
            this.dialogRef.close({data_added:true});
          }
        },
        error: (error: any) => {
          this.commonService.handleError(error);
        },
      });
    }
  }
  onSaveUserAPI() {
    let obj: {} = {
      "u_t": this.dialogData["userType"],
      "u_d": this.userArr
    }
    if (this.userArr.length > 0) {
      this.spinner.show()
      this.userService.addUser(obj).subscribe({
        next: (success : any) => {
          if (success.status == 200) {
            this.spinner.hide();

            this.appService.showToastMessage("success", success.msg);
            this.dialogRef.close({data_added:true});
          }
        },
        error: (error: any) => {
          this.commonService.handleError(error);
        },
      });
    }
  }
  onCancel() {
    this.dialogRef.close()
  }
}
